/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CoreEmbeddableSection/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Error from './Error/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CoreEmbeddableSection({
  children,
  section_type,
  location_id,
  params,
  refresh,
  session_expired_refresh,
  viewPath = "/DesignSystem/CoreEmbeddableSection"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let coreEmbeddedSectionErrorValueData = fromData.useDataValue({ viewPath,
context: 'core_embedded_section',
path: 'error',
})
let coreEmbeddedSectionUrlValueData = fromData.useDataValue({ viewPath,
context: 'core_embedded_section',
path: 'url',
})
let aggregateData = fromHelpers.getView(coreEmbeddedSectionErrorValueData, coreEmbeddedSectionUrlValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}